import { ExternalBankAccount } from "@wingspanhq/wingspan-api-sdk";
import { selectorExternalBankAccountInternationalIPReady } from "./selectorExternalBankAccountInternationalIPReady";
import { selectorExternalBankAccountRtpReady } from "./selectorExternalBankAccountRtpReady";

export const selectorExternalBankAccountIPReady = (
  externalBankAccount: ExternalBankAccount,
  isInternationalUser: boolean
) =>
  (!isInternationalUser &&
    selectorExternalBankAccountRtpReady(externalBankAccount)) ||
  selectorExternalBankAccountInternationalIPReady(externalBankAccount);
